import { render, staticRenderFns } from "./MailProcessingTemplateList.vue?vue&type=template&id=27a110ba&scoped=true"
import script from "./MailProcessingTemplateList.vue?vue&type=script&lang=js"
export * from "./MailProcessingTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a110ba",
  null
  
)

export default component.exports